
import * as cTypes from 'config/ConfigTypes';


export const isRentalObj = ({ item }) => {
    if (item.field == cTypes.RENTALOBJ.field
        && item.value == cTypes.RENTALOBJ.value) {
        return true;
    }
    return false;
}

export const checkRental = ({ searchParams }) => {
    let newFields = [];
    let found = searchParams.fields.find(item => isRentalObj({ item }));
    if (found) {
        searchParams.fields.forEach(item => {
            if (isRentalObj({ item })) {
                newFields.push(...cTypes.RENTAL_CHANGED_DATA);
            } else {
                newFields.push(item);
            }
        });
        if (newFields && newFields.length) searchParams.fields = newFields;
    }

    return searchParams;
}

export const checkAndChangeFields = ({ searchParams }) => {
    if (searchParams && searchParams.fields && searchParams.fields.length) {
        searchParams = checkRental({ searchParams });
    }
    return searchParams;
}